import React from 'react';
import { Form, Button, Modal, ModalHeader, ModalBody, ModalFooter, } from 'reactstrap';

import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { FormGroup, Label } from 'reactstrap';

import { ReduxInput } from '../../components/ReduxInput';
import './InviteClientModel.css';
import { isValidEmail, isRequired } from '../../components/ReduxInput/Validators';


class InviteClientForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      emails: 0,
      pastedFields: []
    };
    this.addEmail = this.addEmail.bind(this);
    this.removeEmail = this.removeEmail.bind(this);
    this.onPaste = this.onPaste.bind(this);
  }

  addEmail() {
    this.setState({
      emails: this.state.emails + 1
    });
  }

  removeEmail() {
    this.setState({
      emails: this.state.emails - 1
    });
  }
  onPaste(e){
    e.preventDefault();
    let string = e.clipboardData.getData('text/plain');
    let array = string.split('\n'); 
    this.setState({
      emails: array.length -1
    }, () => {
      for(let i = 1; i < array.length; i++){
        this.props.change(`email${i-1}`, array[i]);
      }
      this.props.change("email", array[0]);            
    });


  }

  render() {
    let { handleSubmit, toggle } = this.props;
    let fields = [];
    for (let i = 0; i < this.state.emails; i++) {
      fields.push(
        <FormGroup key={i}>
          <Field
            validate={[isRequired, isValidEmail]}
            id={"email" + i}
            name={"email" + i}
            type="text"
            placeholder="example@example.com"
            component={ReduxInput} />
        </FormGroup>
      );
    }
    return <Form onSubmit={handleSubmit} >
      <ModalBody>
        <Label >Email(s)</Label>
        <FormGroup>
          <Field
            validate={[isRequired, isValidEmail]}
            id={"email"}
            name={"email"}
            type="text"
            placeholder="example@example.com"
            onPaste={this.onPaste}
            component={ReduxInput} />
        </FormGroup>
        {fields}
        <FormGroup>
          <i onClick={this.addEmail} className="fa fa-plus fa-plus-hover" aria-hidden="true"></i>
          {" / "}
          <i onClick={this.removeEmail} className="fa fa-minus fa-plus-hover" aria-hidden="true"></i>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button id="inviteSubmit" type="submit" color="primary" >Invite</Button>{' '}
        <Button id="inviteCancelSubmit" color="secondary" onClick={toggle}>Cancel</Button>
      </ModalFooter>
    </Form>;
  }
}


const ReduxInviteClientForm = reduxForm({
  form: 'InviteClientForm', // a unique identifier for this form
})(InviteClientForm);


export default class InviteClientModal extends React.Component {
  render() {
    let { toggle, isOpen, className } = this.props;
    return (
      <Modal isOpen={isOpen} toggle={toggle} className={'modal-primary ' + className}>
        <ModalHeader toggle={toggle}> Invite Client(s) </ModalHeader>
        <ReduxInviteClientForm {...this.props} />
      </Modal>
    );
  }
}

InviteClientModal.propTypes = {
  onSubmit: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/ClientManagement/InviteClientModal.js